<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="100">
      <FormItem label="患者姓名">{{ editModel.patientName }}</FormItem>
      <FormItem label="姓名拼音">{{ editModel.patientNameSpell }}</FormItem>
      <FormItem label="生日">{{ editModel.patientBirthday }}</FormItem>
      <FormItem label="性别">{{ convertSex}}</FormItem>
      <FormItem label="身份证号">{{ editModel.idCardNO }}</FormItem>
      <FormItem label="手机号">{{ editModel.telePhone }}</FormItem>
      <FormItem label="证件号">{{ editModel.identityID }}</FormItem>
      <FormItem label="邮箱">{{ editModel.email }}</FormItem>
      <FormItem label="医保号">{{ editModel.insuranceID }}</FormItem>
      <FormItem label="职业">{{ editModel.occupation }}</FormItem>
      <FormItem label="工作单位">{{ editModel.addressWork }}</FormItem>

      <FormItem label="最后更新时间">{{ editModel.lastUpdateDate }}</FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      organParentName: "",
    };
  },
  computed: {
    convertSex() {
      switch (this.editModel.patientSex) {
        case "F":
          return "女";
        case "M":
          return "男";
        default:
          return "未知";
      }
    },
  },
  created: function () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>